/**
 * BulkDownloadCancelPill — persistent floating pill that shows while a
 * bulk download is running. Tapping it aborts the loop AND the current
 * fetch via `cancelActiveBulkDownload()`.
 *
 * Feb-2026 (user "i think i just accidentaly started a download of all
 * recrodings to my folder please stop it"): before this component the
 * only way to stop a runaway multi-file download was to close the tab.
 * Now every page renders a "Cancel download" pill fixed to the bottom-
 * right while `isBulkDownloadActive()` is true.
 */
import React, { useEffect, useState } from 'react';
import { StopCircle } from 'lucide-react';
import {
  isBulkDownloadActive,
  subscribeBulkDownload,
  cancelActiveBulkDownload,
} from '../utils/downloadRecordings';

const BulkDownloadCancelPill = () => {
  const [active, setActive] = useState(() => isBulkDownloadActive());
  useEffect(() => subscribeBulkDownload(() => setActive(isBulkDownloadActive())), []);
  if (!active) return null;
  return (
    <button
      type="button"
      onClick={cancelActiveBulkDownload}
      data-testid="bulk-download-cancel-pill"
      className="fixed bottom-24 sm:bottom-6 right-4 z-[80] inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-red-600 hover:bg-red-700 text-white text-sm font-bold shadow-[0_10px_28px_-6px_rgba(220,38,38,0.6)] active:scale-95 transition-all"
      aria-label="Cancel the bulk download"
    >
      <StopCircle className="w-4 h-4" />
      Cancel download
    </button>
  );
};

export default BulkDownloadCancelPill;
